
<template>
    <div>
        <b-button @click="download" variant="outline-secondary" class="mr-2">{{ $t('download_excel_template') }}</b-button>
    </div>
</template>

<script>
import excelImportTemplate from "@/services/ExcelImportTemplate";

export default {
    name: "DownloadExcelTemplate",
    props:{
        code:{
            type:String,
            default:null,
            required:true
        }
    },
    methods:{
        download() {
            excelImportTemplate.downloadTemplate(this.code)
                .then(response => {
                    this._downloadFile(response, this.code + '.xlsx')
                })
                .catch(error => {
                    this.showErrors(error,null,true)
                });
        },

    }
}
</script>


<style scoped>

</style>
